theme.RecentlyViewed = (function() {
  var init = false;
  var maxProducts = 4;

  function RecentlyViewed(container) {
    if (!container) {
      return;
    }

    this.container = container;
    this.sectionId = this.container.getAttribute('data-section-id');

    theme.initWhenVisible({
      element: this.container,
      callback: this.init.bind(this),
      threshold: 600
    });
  };

  RecentlyViewed.prototype = Object.assign({}, RecentlyViewed.prototype, {
    init: function() {
      if (init) {
        return;
      }

      init = true;

      // Stop if no data
      if (!theme.recentlyViewedIds.length) {
        this.container.classList.add('hide');
        return;
      }

      this.outputContainer = document.getElementById('RecentlyViewed-' + this.sectionId);
      var currentId = this.container.getAttribute('data-product-id');

      var url = theme.routes.search + '?view=recently-viewed&type=product&q=';

      var products = '';
      var i = 0;
      theme.recentlyViewedIds.forEach(function(val) {
        // Skip Bokksu Digital Gift Card (Multiple Variants)
        if (val === '7483544666307') {
          return;
        }
        
        // Skip current product
        if (val === currentId) {
          return;
        }

        // Stop at max
        if (i >= maxProducts) {
          return;
        }

        products += 'id:' + val + ' OR ';
        i++;
      });

      url = url + encodeURIComponent(products);

      fetch(url).then(function(response) {
        return response.text();
      }).then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var count = doc.querySelectorAll('.grid-product').length;

        if (count > 0) {
          var results = doc.querySelector('.product-grid');
          this.outputContainer.append(results);

          new theme.QuickAdd(this.outputContainer);
          new theme.QuickShop(this.outputContainer);
                yotpoWidgetsContainer.initWidgets()

        } else {
          this.container.classList.add('hide');
        }

      }.bind(this));
    },

    onUnload: function() {
      init = false;
    }
  });

  return RecentlyViewed;
})();

$(document).ready(function() {
  theme.sections = new theme.Sections();
  theme.sections.register('recently-viewed', theme.RecentlyViewed);
//   $('.new-plus-design').hasClass("d-none")? $('.grid-item__meta').css("margin","60px 20px 20px"):$('.grid-item__meta').css("margin","20px 20px 20px");
//   $('.new-plus-design').hasClass("d-none")? $('.plus-minus-icon').removeClass("new-plus-design"):$('.plus-minus-icon').addClass("new-plus-design");
 });
